import React, { useState, useRef, useCallback } from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Guides() {
  const [isMuted, setIsMuted] = useState(true);
  const [isMutedEvent, setIsMutedEvent] = useState(true);
  const videoRef1 = useRef<HTMLVideoElement>(null);
  const videoRef2 = useRef<HTMLVideoElement>(null);

  const toggleMute1 = useCallback(() => {
    setIsMuted(prev => {
      const next = !prev;
      if (videoRef1.current) videoRef1.current.muted = next;
      return next;
    });
  }, []);

  const toggleMute2 = useCallback(() => {
    setIsMutedEvent(prev => {
      const next = !prev;
      if (videoRef2.current) videoRef2.current.muted = next;
      return next;
    });
  }, []);

  return (
    <PageLayout
      title="Strategic Guides"
      subtitle="Master World Cup readiness and optimize your interchange logic."
      badge="KNOWLEDGE BASE"
      imageSrc="/products/art_guides_1776905212048.png"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
        <div className="bg-white p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow cursor-pointer flex flex-col h-full group">
          <div className="bg-green-50 text-green-700 px-3 py-1 rounded w-fit text-xs font-bold mb-4">OPTIMIZATION</div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">Interchange Optimization</h3>
          <p className="text-gray-600 mb-6">Learn how Level II and Level III processing data can automatically downgrade your interchange rates on corporate and purchasing cards by up to 1.00%.</p>
          
          <div className="mt-auto pt-4 relative rounded-xl overflow-hidden border border-gray-100 shadow-sm group/video">
            <video 
              ref={videoRef1}
              src="/videos/The_Invisible_Margin.mp4" 
              autoPlay 
              loop 
              muted 
              playsInline 
              className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500" 
            />
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleMute1();
              }}
              className="absolute bottom-3 right-3 w-8 h-8 flex items-center justify-center bg-black/40 hover:bg-black/60 text-white rounded-full backdrop-blur-md transition-all opacity-0 group-hover/video:opacity-100 z-10"
              aria-label={isMuted ? "Unmute video" : "Mute video"}
            >
              <i className={isMuted ? "ri-volume-mute-fill text-sm" : "ri-volume-up-fill text-sm"} />
            </button>
          </div>
        </div>

        <div className="bg-white p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow cursor-pointer flex flex-col h-full group">
          <div className="bg-purple-50 text-purple-700 px-3 py-1 rounded w-fit text-xs font-bold mb-4">EVENT SCALE</div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">World Cup Readiness</h3>
          <p className="text-gray-600 mb-6">A tactical playbook for deploying Tapn SoftPOS systems across massive event venues without network congestion or hardware shortages.</p>
          
          <div className="mt-auto pt-4 relative rounded-xl overflow-hidden border border-gray-100 shadow-sm group/video">
            <video 
              ref={videoRef2}
              src="/videos/Tapn_SoftPOS_-_The_Frictionless_Pulse.mp4" 
              autoPlay 
              loop 
              muted 
              playsInline 
              className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500" 
            />
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleMute2();
              }}
              className="absolute bottom-3 right-3 w-8 h-8 flex items-center justify-center bg-black/40 hover:bg-black/60 text-white rounded-full backdrop-blur-md transition-all opacity-0 group-hover/video:opacity-100 z-10"
              aria-label={isMutedEvent ? "Unmute video" : "Mute video"}
            >
              <i className={isMutedEvent ? "ri-volume-mute-fill text-sm" : "ri-volume-up-fill text-sm"} />
            </button>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
